var map = {
	"./bg.png": "yRcn",
	"./header.png": "nvbl",
	"./header_logo.png": "oHgo",
	"./left-bg.jpg": "mW6j",
	"./logo.png": "iQH9",
	"./logo_1.png": "Cz8E",
	"./svgs": "fc3b",
	"./svgs.vue": "fc3b",
	"./user.png": "AGL3",
	"./wuhan.png": "EjCf"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "g2Y0";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*$
// module id = g2Y0
// module chunks = 3